import { Theme } from '@mui/material';


const Popover = (theme: Theme) => {
  return {
  };
};

export default Popover;
